import {FreeClassicsMetadata} from '@app/free-classics/free-classics-types';

export function resolveDefaultFreeClassicsDecade(
  metadata: FreeClassicsMetadata,
): number {
  if (!metadata.decades.length) {
    return Math.floor(new Date().getFullYear() / 10) * 10;
  }

  const best = [...metadata.decades].sort(
    (a, b) => b.titles_count - a.titles_count,
  )[0];

  return best?.decade ?? metadata.max_decade ?? metadata.decades[0].decade;
}

export function formatDecadeLabel(decade: number): string {
  return `${decade}s`;
}
